import {
  Modal as HeroUiModal,
  ModalProps as HeroUiModalProps,
  extendVariants,
} from '@heroui/react';
import { ExitIcon } from '@icons';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { ModalVariant } from './ModalConstants';

export interface ModalProps extends HeroUiModalProps {
  variant?: ModalVariant;
  onClose?: () => void | Promise<void>;
}

const ModalComponent = extendVariants(HeroUiModal, {
  variants: {
    variant: {
      default: {
        wrapper: '',
        backdrop: '',
        base: 'rounded-medium',
        header: '',
        body: '',
        footer: '',
        closeButton: '',
      },
      alert: {
        wrapper: '',
        backdrop: '',
        base: 'rounded-medium',
        header: '',
        body: '',
        footer: '',
        closeButton: 'hidden',
      },
    },
    size: {
      xs: {
        base: 'max-w-[18rem] w-fit',
      },
    },
    isCentered: {},
    isScrollable: {},
    isDismissable: {},
    isKeyboardDismissDisabled: {},
    isBackdropDismissDisabled: {},
  },
  defaultVariants: {
    variant: 'default',
  },
}) as ForwardRefExoticComponent<Omit<ModalProps, 'ref'> & RefAttributes<HTMLElement | null>>;

export function Modal({ ...props }: ModalProps) {
  return <ModalComponent {...props} closeButton={<ExitIcon />} />;
}

export { ModalContent, ModalHeader, ModalBody, ModalFooter } from '@heroui/react';
